var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonTable',{staticClass:"table",attrs:{"listArray":_vm.values,"sort":_vm.sort,"headers":_vm.headers,"slots":_vm.slots,"actions":_vm.actions,"resource":"analysis","loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }